import { Select, TextFieldAppearance, TextFieldSize } from '@bechtel/gds';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { find } from 'lodash';
import { useEffect, useState } from 'react';
import { MultiLingualText } from '~/components';
import { isFieldEditable } from '../../utils';
import { GridCellContainer } from './styled';

interface CustomCellRendererParams extends ICellRendererParams {
  onRowEdited?: (updatedRowData: any) => void; // This includes the onRowEdited function
  rowHeight: string;
}

const SelectedItemComponent = ({ item }: { item }) => {
  return <MultiLingualText size="250">{item.description}</MultiLingualText>;
};
const SelectItemComponent = ({ item }: { item }) => {
  return <MultiLingualText size="250">{item.description}</MultiLingualText>;
};

export const SelectCellRenderer = (props: CustomCellRendererParams) => {
  const [cellValue, setCellValue] = useState(props.value);
  const listData = props?.colDef?.cellEditorParams && props.colDef?.cellEditorParams(props);
  const editable = isFieldEditable(props?.colDef?.editable, props);
  const selectedItem = cellValue && find(listData, (selectListItem) => selectListItem.id === cellValue);

  useEffect(() => {
    setCellValue(props.value);
  }, [props.value]);

  const handleSelectChange = (changes) => {
    const newValue = changes.selectedItem.value;
    setCellValue(changes.selectedItem.value);

    // Call onRowEdited with the updated value
    if (props.onRowEdited && props?.colDef?.field) {
      const updatedValue = { ...props.data, [props.colDef.field]: newValue };

      props.onRowEdited(updatedValue);
      // need to update the grid data when updated in server grid
      props.node?.setData(updatedValue);
    }
  };

  return (
    <GridCellContainer rowHeight={props?.rowHeight}>
      <Select
        items={listData}
        placeholder=""
        itemComponent={SelectItemComponent}
        selectedComponent={SelectedItemComponent}
        selectedItem={selectedItem}
        onSelectedItemChange={handleSelectChange}
        dropDownIconName="angle-up"
        dropDownIconStyle="solid"
        size={TextFieldSize.SMALL}
        appearance={TextFieldAppearance.TRANSPARENT}
        disabled={!editable}
      />
    </GridCellContainer>
  );
};
